export enum BuildTripReorderStatusType {
  Reorder_Required = 1,
  Reorder_NotRequired = 2,
  Reorder_NotRequired_DontPromptInstore = 3
}
